<template>
  <div class="container-fluid" :key="hasMods">
    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />

    <div class="card height-responsive">
      <!-- <div class="card-header">Configuration des documents de production</div> -->
      <div class="card-body height-responsive-body height-responsive-1b">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="form-group col-7">
                  <label class="cursor-pointer" :for="'Agrement' + currentEtab.eId" v-tooltip="{ content: 'Numéro sans la mention FR/CE.\nExemple : 33.535.999'}">Agrément sanitaire</label>
                  <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'Agrement' + currentEtab.eId" maxlength="20" type="text" v-model="currentEtab.objDS.NUMAGREMENT" placeholder="Ex : 33.535.999">
                </div>
                <div class="form-group col-5">
                  <label class="cursor-pointer" :for="'EtablissementDlcPortage' + currentEtab.eId" v-tooltip="{ content: 'Valeur en J+ jours de la DLC souhaitée. (J+3 par défaut si champs vide).'}">DLC par défaut</label>
                  <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'EtablissementDlcPortage' + currentEtab.eId" type="number" step="1" v-model="currentEtab.objDS.EtablissementDlcPortage">
                </div>
              </div>

              <div class="card">
                <div class="card-header">
                  Fiches de production
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-12">
                      <label v-tooltip="{ content: 'Ajoute aux fiches de production un récaptitulatif de la répartition des recettes par lieu de portage.'}">Intégrer la répartition par lieu de portage</label>
                      <fieldset class="flex-start">
                        <div class="custom-control custom-radio mr-5">
                          <input type="radio" class="custom-control-input" name="repartprod" value="non" id="repartprod-non" v-model="currentEtab.objDS.RepartitionProdParLieu" @input="hasMods = true">
                          <label class="custom-control-label cursor-pointer" for="repartprod-non">Non</label>
                        </div>
                        <div class="custom-control custom-radio mr-5">
                          <input type="radio" class="custom-control-input" name="repartprod" value="ouifin" id="repartprod-ouifin" v-model="currentEtab.objDS.RepartitionProdParLieu" @input="hasMods = true">
                          <label class="custom-control-label cursor-pointer" for="repartprod-ouifin">Oui, en fin de document</label>
                        </div>
                        <div class="custom-control custom-radio">
                          <input type="radio" class="custom-control-input" name="repartprod" value="ouiintegre" id="repartprod-ouiintegre" v-model="currentEtab.objDS.RepartitionProdParLieu" @input="hasMods = true">
                          <label class="custom-control-label cursor-pointer" for="repartprod-ouiintegre">Oui, dans chaque recette</label>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  Bons de livraison
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-lg-4 col-md-6 col-sm-12">
                      <label class="cursor-pointer" :for="'BLDoubleExemplaire' + currentEtab.eId" v-tooltip="{ content: 'Duplique les bons de livraisons en une version `Cuisine` et une `Client`.'}">Double exemplaire</label><br />
                      <ToggleButton v-model="currentEtab.objDS.BLDoubleExemplaire" :key="currentEtab.objDS.BLDoubleExemplaire" @input="hasMods = true" :id="'BLDoubleExemplaire' + currentEtab.eId" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" />
                    </div>
                    <div class="form-group col-lg-4 col-md-6 col-sm-12">
                      <label class="cursor-pointer" :for="'BLControleDetaille' + currentEtab.eId" v-tooltip="{ content: 'Si à Oui, affiche un contrôle détaillé pour chaque recette du BL.'}">Contrôle détaillé par recette</label><br />
                      <ToggleButton v-model="currentEtab.objDS.BLControleDetaille" :key="currentEtab.objDS.BLControleDetaille" @input="hasMods = true" :id="'BLControleDetaille' + currentEtab.eId" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" />
                    </div>
                    <fieldset class="form-group col-lg-4 col-md-6 col-sm-12">
                      <label class="cursor-pointer" :for="'BLAfficherDouteAllergene' + currentEtab.eId" v-tooltip="{ content: 'Affiche dans les bons de livraison `????` en cas de doute sur les allergènes.'}">Afficher le doute sur allergène</label><br />
                      <ToggleButton v-model="currentEtab.objDS.BLAfficherDouteAllergene" :key="currentEtab.objDS.BLAfficherDouteAllergene" @input="hasMods = true" :id="'BLAfficherDouteAllergene' + currentEtab.eId" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" />
                    </fieldset>
                    <div class="w-100"></div>
                    <fieldset class="form-group col-lg-4 col-md-6 col-sm-12">
                      <label class="cursor-pointer" :for="'BLAfficherEffectifVide' + currentEtab.eId" v-tooltip="{ content: 'Si à Oui, les lieux sans effectifs sont tout de même générés dans les bons de livraison.'}">Imprimer les lieux sans effectif</label><br />
                      <ToggleButton v-model="currentEtab.objDS.BLAfficherEffectifVide" :key="currentEtab.objDS.BLAfficherEffectifVide" @input="hasMods = true" :id="'BLAfficherEffectifVide' + currentEtab.eId" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" />
                    </fieldset>
                    <fieldset class="form-group col-lg-4 col-md-6 col-sm-12">
                      <label class="cursor-pointer" :for="'BLAfficherEtiquettes' + currentEtab.eId" v-tooltip="{ content: 'Affiche les étiquettes dans les bons de livraison de portage.'}">&Eacute;tiquettes au verso (format spécifique)</label><br />
                      <ToggleButton v-model="currentEtab.objDS.BLAfficherEtiquettes" :key="currentEtab.objDS.BLAfficherEtiquettes" @input="hasMods = true" :id="'BLAfficherEtiquettes' + currentEtab.eId" :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#16D39A', unchecked: '#CCCCCC'}" :height="30" :width="85" />
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  Refroidissement
                </div>
                <div class="card-body">
                  <div class="note">Personnalisation des valeurs de refroidissement</div>
                  <div class="row">
                    <fieldset class="form-group col-lg-6 col-md-6 col-sm-12">
                      <label class="cursor-pointer" :for="'RefroidissementValeur' + currentEtab.eId" v-tooltip="{ content: 'Valeur par défaut : 2h maximum entre +63°C et +3°C à coeur.\nMaximum 50 caractères.' }">Valeur retenue</label>
                      <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'RefroidissementValeur' + currentEtab.eId" type="text" v-model="currentEtab.objDS.RefroidissementValeur" 
                              placeholder="Ex : 2h maximum entre +63°C et +3°C à coeur" maxlength="50" />
                    </fieldset>
                    <fieldset class="form-group col-lg-6 col-md-6 col-sm-12">
                      <label class="cursor-pointer" :for="'RefroidissementTolerance' + currentEtab.eId" v-tooltip="{ content: 'Valeur par défaut : Jusqu\'à 2h de la fin de cuisson à +10°C.\nMaximum 50 caractères.' }">Tolérance admise</label>
                      <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'RefroidissementTolerance' + currentEtab.eId" type="text" v-model="currentEtab.objDS.RefroidissementTolerance" 
                              placeholder="Ex : Jusqu'à 2h de la fin de cuisson à +10°C" maxlength="50" />
                    </fieldset>
                    <fieldset class="form-group col-lg-12 col-md-12 col-sm-12">
                      <label class="cursor-pointer" :for="'RefroidissementAction1' + currentEtab.eId" v-tooltip="{ content: 'Liste des actions correctives en cas de dépassement de la tolérance.\nMaximum 60 caractères par ligne.' }">Actions correctives en cas de dépassement de la tolérance</label>
                      <div class="input-group">
                        <label class="input-group-text cursor-pointer" :for="'RefroidissementAction1' + currentEtab.eId">Ligne 1</label>
                        <input @focus="$event.target.select()" @input="hasMods = true" class="form-control pl-2" :id="'RefroidissementAction1' + currentEtab.eId" type="text" v-model="currentEtab.objDS.RefroidissementAction1" 
                              placeholder="Ex : Nouvelle prise de température" maxlength="60" />
                      </div>
                      <div class="input-group">
                        <label class="input-group-text cursor-pointer" :for="'RefroidissementAction2' + currentEtab.eId">Ligne 2</label>
                        <input @focus="$event.target.select()" @input="hasMods = true" class="form-control pl-2" :id="'RefroidissementAction2' + currentEtab.eId" type="text" v-model="currentEtab.objDS.RefroidissementAction2" 
                              placeholder="Ex : Destruction des lots" maxlength="60" />
                      </div>
                      <div class="input-group">
                        <label class="input-group-text cursor-pointer" :for="'RefroidissementAction3' + currentEtab.eId">Ligne 3</label>
                        <input @focus="$event.target.select()" @input="hasMods = true" class="form-control pl-2" :id="'RefroidissementAction3' + currentEtab.eId" type="text" v-model="currentEtab.objDS.RefroidissementAction3" 
                              placeholder="Ex : Mise en place d'un menu de substitution" maxlength="60" />
                      </div>
                      <div class="input-group">
                        <label class="input-group-text cursor-pointer" :for="'RefroidissementAction4' + currentEtab.eId">Ligne 4</label>
                        <input @focus="$event.target.select()" @input="hasMods = true" class="form-control pl-2" :id="'RefroidissementAction4' + currentEtab.eId" type="text" v-model="currentEtab.objDS.RefroidissementAction4" 
                              maxlength="60" />
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import BarreActions from '@/components/Divers/BarreActions'
import { setInfosEtablissement } from '@/api/gpao/user'
import { connecteData } from "@/mixins/connecteData"
import { showAlerts } from "@/mixins/alerts"
import vm from "@/helpers/vm-toolkit-vue"

export default {
  components: { BarreActions },
  mixins: [ connecteData, showAlerts ],
  name: "PageConfigurationProduction",
  data() {
    return {
      currentEtab: { eId: 0 ,objDS: {}},
      hasMods: false,
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        enregistrer: {
          label: "Enregistrer",
          disabled: true,
          class: "btn-success",
          async methode(contexte) {
            contexte.saveEtab()
          }
        },
        annuler: {
          label: "Annuler",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            contexte.annuler(contexte.etabCourantId)
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ ]
          contexte.actions.barreDroite = [ contexte.actions.annuler, contexte.actions.enregistrer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.enregistrer, actions.annuler ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }
      }
    }
  },
  mounted() {
    this.actions.initialiser(this)
  },
  created() {
    this.selectEtab(this.etabCourantId)
  },
  beforeRouteLeave(to, from, next) {
    console.log('checkRouteProfile')
    return this.askSave()
      .then(result => {
        if (result) {
          // Enregistrement de l'établissement
          this.saveEtab()
        }
        // eslint-disable-next-line promise/no-callback-in-promise
        next()
        return
      })
  },
  computed: {
    infoModifiee() {
      return this.hasMods
    }
  },
  watch: {
    infoModifiee() {
      this.actions.disable(this.actions, !this.infoModifiee)
    }
  },
  methods: {
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    async selectEtab(etablissementId) {
      let result = await this.askSave()
      if (!result) {
        this.annuler(etablissementId)
      }
    },
    annuler(etablissementId) {
        this.currentEtab = vm.clone(this.utilisateurCourant.etablissements.find(el => el.eId === etablissementId))
        this.currentEtab.objDS={}
        if (this.currentEtab.donneesSupplementaires) {
          this.currentEtab.objDS=JSON.parse(this.currentEtab.donneesSupplementaires)
        }
        this.hasMods = false
    },
    saveEtab() {
      if (!this.currentEtab.objDS.NUMAGREMENT)
        delete this.currentEtab.objDS.NUMAGREMENT
      if (!this.currentEtab.objDS.RepartitionProdParLieu)
        delete this.currentEtab.objDS.RepartitionProdParLieu
      if (!this.currentEtab.objDS.BLAfficherDouteAllergene)
        delete this.currentEtab.objDS.BLAfficherDouteAllergene
      if (!this.currentEtab.objDS.EtablissementDlcPortage)
        delete this.currentEtab.objDS.EtablissementDlcPortage
      if (!this.currentEtab.objDS.BLAfficherEtiquettes)
        delete this.currentEtab.objDS.BLAfficherEtiquettes
      if (!this.currentEtab.objDS.BLDoubleExemplaire)
        delete this.currentEtab.objDS.BLDoubleExemplaire
      if (!this.currentEtab.objDS.BLControleDetaille)
        delete this.currentEtab.objDS.BLControleDetaille
      if (!this.currentEtab.objDS.BLAfficherEffectifVide)
        delete this.currentEtab.objDS.BLAfficherEffectifVide
      if (!this.currentEtab.objDS.RefroidissementValeur)
        delete this.currentEtab.objDS.RefroidissementValeur
      if (!this.currentEtab.objDS.RefroidissementTolerance)
        delete this.currentEtab.objDS.RefroidissementTolerance
      if (!this.currentEtab.objDS.RefroidissementAction1)
        delete this.currentEtab.objDS.RefroidissementAction1
      if (!this.currentEtab.objDS.RefroidissementAction2)
        delete this.currentEtab.objDS.RefroidissementAction2
      if (!this.currentEtab.objDS.RefroidissementAction3)
        delete this.currentEtab.objDS.RefroidissementAction3
      if (!this.currentEtab.objDS.RefroidissementAction4)
        delete this.currentEtab.objDS.RefroidissementAction4
      if (!this.currentEtab.objDS.MasquerStructMenusAgap)
        delete this.currentEtab.objDS.MasquerStructMenusAgap
      this.currentEtab.donneesSupplementaires=JSON.stringify(this.currentEtab.objDS)
      setInfosEtablissement(this.currentEtab)
        .then(function () {
          this.$store.commit('user/setInfosEtablissement', this.currentEtab)
          this.hasMods = false
          this.toastSucces('Modifications enregistrées')
        }.bind(this))
        .catch(e => {
          console.error(e)
          this.toastErreur("Echec de l'enregistrement")
        })
    },
    async askSave() {
      if (!this.hasMods) {
        return Promise.resolve(false)
      }
      return this.alerteConfirmationEnregistrement()
    }
  }
}
</script>
